export default __webpack_public_path__ + "media/components/Pages/Index/Images/graduate-b962c7ef9ad17b61a1c1811a8d4d4f3c.jpg";